import { colors } from '@creditornot/cb-ingredients';
import { cssThemedValue } from '@creditornot/cb-sc-utils';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Typography as T } from 'common/typography';
import { MenuRow } from 'modules/insights-v2/types';

const Root = styled.div`
  align-items: center;
  display: flex;
  gap: 16px;
`;
const MenuInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;
const OrderCount = styled.small`
  color: ${cssThemedValue({ light: colors.pepper64, dark: colors.salt72 })};
`;
const InsightMenuRow = ({ data: { icon, itemsCount, title } }: { data: MenuRow }) => {
  return (
    <Root>
      {icon}
      <MenuInfo>
        <T.Body2>{title}</T.Body2>
        <OrderCount>
          <FormattedMessage id="insights.menu.items" values={{ itemsCount }} />
        </OrderCount>
      </MenuInfo>
    </Root>
  );
};

export default InsightMenuRow;
